import React, {Component} from 'react';

import {Translate} from 'react-localize-redux';
import {connect} from 'react-redux';
import TranslationViewer from '../../03-components/TranslationViewer';
import './style.css';
import {loadCategories} from "../../01-actions/adminCategories";
import NicePanel from "../NicePanel/index";
import TwoLevelCollapseMenu from "../../03-components/TwoLevelCollapseMenu/index";
import bulletImage from '../../06-assets/images/home/bullet.png';
import {withRouter} from 'react-router-dom';

class MainMenu extends Component {
    constructor(props) {
        super(props);
        this.props.fetchAllCategories();
    }

    render() {

        //-- construct a two-level categories
        let categories = this.props.categories.map((cat) => {
            return Object.assign({}, cat);
        });

        for (let i = 0; i < categories.length; i++) {
            for (let j = 0; j < categories.length; j++) {
                if (categories[j].parentId && categories[j].parentId === categories[i]._id) {
                    if (!categories[i].subCategories) categories[i].subCategories = [];
                    categories[i].subCategories.push(categories[j]);
                }
            }
        }
        //-- first level categories
        let firstLevel = categories.filter(cat => !cat.parentId).sort((m1, m2) => (m1.order - m2.order));

        const menu = firstLevel.map((cat) => {
            return {
                title: <div className="d-flex align-items-center">
                    <img alt="bullet" className="margin-right-15px" src={bulletImage}/>
                    <TranslationViewer
                        value={cat.name}/>
                </div>,
                menu: cat.subCategories && cat.subCategories.sort((s1, s2) => (s1.order - s2.order)).map(subCat => {
                    return {
                        title: <div className="d-flex">
                            <span className="margin-right-15px">‣</span>
                            <TranslationViewer value={subCat.name}/>
                        </div>
                    }
                })
            };
        });

        return (
            <Translate>
                {({translate}) => (
                    <div className="con-mainmenu">
                        <NicePanel title={translate("categories")}>
                            <TwoLevelCollapseMenu
                                activeClassName="active"
                                menu={menu}
                                onMenuClick={(level, index) => {
                                    if (level === 1) {
                                        this.props.history.push(`/products?categoryId=${firstLevel[index[0]].subCategories[index[1]]._id}`);
                                    }
                                    // else if (level === 0) {
                                    // 	this.props.history.push(`/products?categoryId=${firstLevel[index]._id}`);
                                    // }
                                }}
                            />
                        </NicePanel>
                    </div>
                )}
            </Translate>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        images: store.adminImages.images,
        categories: store.adminCategories.categories
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAllCategories: () => {
            dispatch(loadCategories());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainMenu));


// WEBPACK FOOTER //
// ./src/04-containers/MainMenu/index.js